import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ListItemData } from './list-item-data';


@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrl: './list-item.component.scss'
})
export class ListItemComponent implements OnInit {
  @Input() listItems:ListItemData[] = [];
  @Output() clickItem = new EventEmitter<ListItemData>();

  ngOnInit(): void {
    
  }

  actionclick($event) {
    this.clickItem.emit($event);
  }
}

